import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Typography,
  TextField,
  FormControlLabel,
  Switch,
  Button,
} from '@material-ui/core'
import { Alert } from '@material-ui/lab'
import { useForm, Controller } from 'react-hook-form'

import * as service from 'service'
import constants from 'constants/index'
import helpers from 'helpers'

import useSnackbar from 'hooks/useSnackbar'

import schema from './schema'

const DeadlineForm = ({ category, categoryId, onRefresh, setLoading }) => {
  const snackbar = useSnackbar()

  const { control, errors, handleSubmit, reset } = useForm({
    validationSchema: schema,
    defaultValues: {
      deadlineDay: '',
      companyDeadlineDay: '',
    },
  })

  const categoryLabel = () =>
    category?.customizable
      ? constants.complaint.CATEGORY_TYPE_LABELS.CUSTOMIZABLE
      : constants.complaint.CATEGORY_TYPE_LABELS.PREDEFINED

  useEffect(() => {
    if (!category) return

    reset({
      deadlineDay: category.deadlineDay ?? '',
      companyDeadlineDay: category.companyDeadlineDay ?? '',
    })
  }, [category, reset])

  const handleSaveDeadlines = async (data) => {
    try {
      setLoading(true)
      await service.dponet.complaintCategories.update(categoryId, {
        complaintCategory: {
          deadlineDay: Number(data.deadlineDay),
          companyDeadlineDay: Number(data.companyDeadlineDay),
        },
      })
      snackbar.open({
        message: 'Prazos atualizados com sucesso!',
        variant: 'success',
      })
      onRefresh()
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error, false) ||
          'Erro ao atualizar os prazos',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Box p={3}>
      <Typography color="primary" variant="subtitle1">
        Informações
      </Typography>

      <Box display="flex" flexDirection="column" gridGap={16} pt={2}>
        <Alert severity="info">
          <strong>Alteração aplicada apenas às novas denúncias.</strong> As
          denúncias já recebidas manterão o prazo vigente no momento do seu
          registro. O novo prazo valerá somente para denúncias recebidas após a
          confirmação desta alteração.
        </Alert>

        <TextField
          fullWidth
          label="Nome"
          variant="outlined"
          value={category?.name || ''}
          disabled
        />

        <Controller
          as={
            <TextField
              fullWidth
              required
              type="number"
              label="Prazo total (dias)"
              variant="outlined"
              error={!!errors.deadlineDay}
              helperText={errors?.deadlineDay?.message}
              inputProps={{ min: 1 }}
            />
          }
          control={control}
          name="deadlineDay"
          mode="onBlur"
        />

        <Controller
          as={
            <TextField
              fullWidth
              required
              type="number"
              label="Prazo de primeira resposta (dias)"
              variant="outlined"
              error={!!errors.companyDeadlineDay}
              helperText={errors?.companyDeadlineDay?.message}
              inputProps={{ min: 1 }}
            />
          }
          control={control}
          name="companyDeadlineDay"
          mode="onBlur"
        />

        <FormControlLabel
          label={categoryLabel}
          labelPlacement="end"
          control={
            <Switch
              color="primary"
              checked={category?.customizable || false}
              disabled
            />
          }
        />

        <Box display="flex" justifyContent="flex-end">
          <Button
            variant="contained"
            color="primary"
            onClick={handleSubmit(handleSaveDeadlines)}
          >
            Salvar prazos
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

DeadlineForm.propTypes = {
  category: PropTypes.object,
  categoryId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onRefresh: PropTypes.func,
  setLoading: PropTypes.func,
}

export default DeadlineForm
